export default function DashboardNodes(){
  return (<div>
    Dashboard Nodes
    </div>);
}